// ─── CHAIN ICONS ─────────────────────────────────────────────────────────────
// Covers every chain returned by SwapKit (THORCHAIN, MAYA, CHAINFLIP,
// FLASHNET, NEARINTENTS, MAYAN, ONEINCH, JUPITER, GARDEN, HARBOR),
// plus Baltex, Mayan Finance, StealthEX, Exolix, and 1Click providers.

export const CHAIN_ICONS = {
  // ── Core L1s ──────────────────────────────────────────────────────────────
  Bitcoin:          'https://assets.coingecko.com/coins/images/1/small/bitcoin.png',
  Ethereum:         'https://assets.coingecko.com/coins/images/279/small/ethereum.png',
  Solana:           'https://assets.coingecko.com/coins/images/4128/small/solana.png',
  Monero:           'https://assets.coingecko.com/coins/images/69/small/monero_logo.png',
  Litecoin:         'https://assets.coingecko.com/coins/images/2/small/litecoin.png',
  Dogecoin:         'https://assets.coingecko.com/coins/images/5/small/dogecoin.png',
  XRP:              'https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png',
  Cardano:          'https://assets.coingecko.com/coins/images/975/small/cardano.png',
  Polkadot:         'https://assets.coingecko.com/coins/images/12171/small/polkadot.png',
  Cosmos:           'https://assets.coingecko.com/coins/images/1481/small/cosmos_hub.png',
  Stellar:          'https://assets.coingecko.com/coins/images/100/small/Stellar_symbol_black_RGB.png',
  Tron:             'https://assets.coingecko.com/coins/images/1094/small/tron-logo.png',
  Dash:             'https://assets.coingecko.com/coins/images/19/small/dash-logo.png',
  Zcash:            'https://assets.coingecko.com/coins/images/486/small/circle-zcash-color.png',
  'Bitcoin Cash':   'https://assets.coingecko.com/coins/images/780/small/bitcoin-cash-circle.png',

  // ── EVM L2s & Sidechains ──────────────────────────────────────────────────
  Base:             'https://assets.coingecko.com/coins/images/31181/small/base.png',
  Arbitrum:         'https://assets.coingecko.com/coins/images/16547/small/arb.jpg',
  Optimism:         'https://assets.coingecko.com/coins/images/25244/small/Optimism.png',
  Polygon:          'https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png',
  'BNB Chain':      'https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png',
  Avalanche:        'https://assets.coingecko.com/coins/images/12559/small/Avalanche_Circle_RedWhite_Trans.png',
  Gnosis:           'https://assets.coingecko.com/coins/images/662/small/logo_square_simple_300px.png',
  Fantom:           'https://assets.coingecko.com/coins/images/4001/small/Fantom.png',
  'X Layer':        'https://assets.coingecko.com/coins/images/33066/small/okb.png',
  HyperEVM:         'https://assets.coingecko.com/coins/images/34229/small/hyperliquid.png',
  Monad:            'https://assets.coingecko.com/coins/images/36657/small/monad.png',
  Berachain:        'https://assets.coingecko.com/coins/images/36923/small/berachain.png',
  Scroll:           'https://assets.coingecko.com/coins/images/26949/small/scroll.png',
  Starknet:         'https://assets.coingecko.com/coins/images/26433/small/starknet.png',
  Linea:            'https://assets.coingecko.com/coins/images/28206/small/linea.png',
  zkSync:           'https://assets.coingecko.com/coins/images/24091/small/zksync.png',
  Mantle:           'https://assets.coingecko.com/coins/images/30980/small/mantle.png',
  Manta:            'https://assets.coingecko.com/coins/images/31463/small/manta.png',
  Blast:            'https://assets.coingecko.com/coins/images/35494/small/blast.png',
  Mode:             'https://assets.coingecko.com/coins/images/36974/small/mode.png',
  Plasma:           'https://assets.coingecko.com/coins/images/33067/small/xpl.png',
  Hypercore:        'https://assets.coingecko.com/coins/images/33068/small/hypercore.png',
  Abstract:         'https://assets.coingecko.com/coins/images/33069/small/abstract.png',
  Robinhood:        'https://assets.coingecko.com/coins/images/1/small/bitcoin.png', // HOOD chain (tokenized stocks)

  // ── Non-EVM newer chains ──────────────────────────────────────────────────
  TON:              'https://assets.coingecko.com/coins/images/17980/small/ton_symbol.png',
  Sui:              'https://assets.coingecko.com/coins/images/26375/small/sui_asset.jpeg',
  Aptos:            'https://assets.coingecko.com/coins/images/26455/small/aptos_round.png',
  Near:             'https://assets.coingecko.com/coins/images/10365/small/near.png',
  Aleo:             'https://assets.coingecko.com/coins/images/36958/small/aleo.png',
  Movement:         'https://assets.coingecko.com/coins/images/36957/small/movement.png',
  Stacks:           'https://assets.coingecko.com/coins/images/2069/small/Stacks_logo_full.png',
  Radix:            'https://assets.coingecko.com/coins/images/4374/small/Radix.png',
  Kujira:           'https://assets.coingecko.com/coins/images/25810/small/kuji.png',

  // ── Protocol / DEX chains (SwapKit-specific) ──────────────────────────────
  THORChain:        'https://assets.coingecko.com/coins/images/13677/small/RUNE_ICON.png',
  'Maya Protocol':  'https://assets.coingecko.com/coins/images/30172/small/maya.png',
};

// ─── TOKEN ICONS ─────────────────────────────────────────────────────────────
// Lookup is by uppercase symbol. When the same symbol exists on many chains
// (USDC, USDT, WETH, etc.) one canonical icon is used -- the TokenImage
// component falls back to this map before trying a live URL.

export const TOKEN_ICONS = {

  // ── Native gas tokens ─────────────────────────────────────────────────────
  BTC:      'https://assets.coingecko.com/coins/images/1/small/bitcoin.png',
  ETH:      'https://assets.coingecko.com/coins/images/279/small/ethereum.png',
  SOL:      'https://assets.coingecko.com/coins/images/4128/small/solana.png',
  XMR:      'https://assets.coingecko.com/coins/images/69/small/monero_logo.png',
  BNB:      'https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png',
  ADA:      'https://assets.coingecko.com/coins/images/975/small/cardano.png',
  XRP:      'https://assets.coingecko.com/coins/images/44/small/xrp-symbol-white-128.png',
  DOGE:     'https://assets.coingecko.com/coins/images/5/small/dogecoin.png',
  LTC:      'https://assets.coingecko.com/coins/images/2/small/litecoin.png',
  BCH:      'https://assets.coingecko.com/coins/images/780/small/bitcoin-cash-circle.png',
  DASH:     'https://assets.coingecko.com/coins/images/19/small/dash-logo.png',
  ZEC:      'https://assets.coingecko.com/coins/images/486/small/circle-zcash-color.png',
  XLM:      'https://assets.coingecko.com/coins/images/100/small/Stellar_symbol_black_RGB.png',
  TRX:      'https://assets.coingecko.com/coins/images/1094/small/tron-logo.png',
  TON:      'https://assets.coingecko.com/coins/images/17980/small/ton_symbol.png',
  SUI:      'https://assets.coingecko.com/coins/images/26375/small/sui_asset.jpeg',
  APT:      'https://assets.coingecko.com/coins/images/26455/small/aptos_round.png',
  NEAR:     'https://assets.coingecko.com/coins/images/10365/small/near.png',
  DOT:      'https://assets.coingecko.com/coins/images/12171/small/polkadot.png',
  ATOM:     'https://assets.coingecko.com/coins/images/1481/small/cosmos_hub.png',
  AVAX:     'https://assets.coingecko.com/coins/images/12559/small/Avalanche_Circle_RedWhite_Trans.png',
  MATIC:    'https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png',
  POL:      'https://assets.coingecko.com/coins/images/32440/small/polygon.png',
  FTM:      'https://assets.coingecko.com/coins/images/4001/small/Fantom.png',
  ONE:      'https://assets.coingecko.com/coins/images/4344/small/Y88AaTe.png',
  KAS:      'https://assets.coingecko.com/coins/images/25751/small/kaspa.png',
  HBAR:     'https://assets.coingecko.com/coins/images/3688/small/hbar.png',
  ETC:      'https://assets.coingecko.com/coins/images/453/small/ethereum-classic-logo.png',
  ALGO:     'https://assets.coingecko.com/coins/images/4380/small/download.png',
  VET:      'https://assets.coingecko.com/coins/images/1167/small/VET_Token_Icon.png',
  XTZ:      'https://assets.coingecko.com/coins/images/976/small/Tezos-logo.png',
  MOVE:     'https://assets.coingecko.com/coins/images/36957/small/movement.png',
  BERA:     'https://assets.coingecko.com/coins/images/36923/small/berachain.png',
  ALEO:     'https://assets.coingecko.com/coins/images/36958/small/aleo.png',
  HYPE:     'https://assets.coingecko.com/coins/images/34229/small/hyperliquid.png',

  // ── THORChain / Maya Protocol ─────────────────────────────────────────────
  RUNE:     'https://assets.coingecko.com/coins/images/13677/small/RUNE_ICON.png',
  CACAO:    'https://assets.coingecko.com/coins/images/30172/small/maya.png',
  KUJI:     'https://assets.coingecko.com/coins/images/25810/small/kuji.png',

  // ── Stablecoins ───────────────────────────────────────────────────────────
  USDT:     'https://assets.coingecko.com/coins/images/325/small/Tether.png',
  USDC:     'https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png',
  DAI:      'https://assets.coingecko.com/coins/images/9956/small/4943.png',
  TUSD:     'https://assets.coingecko.com/coins/images/3449/small/tusd.png',
  BUSD:     'https://assets.coingecko.com/coins/images/31273/small/new_binance-usd.png',
  FRAX:     'https://assets.coingecko.com/coins/images/13422/small/frax.png',
  USDD:     'https://assets.coingecko.com/coins/images/26092/small/USDD.png',
  GUSD:     'https://assets.coingecko.com/coins/images/5765/small/gemini-dollar-gusd.png',
  PYUSD:    'https://assets.coingecko.com/coins/images/31212/small/PYUSD_Logo_%282%29.png',
  FDUSD:    'https://assets.coingecko.com/coins/images/31079/small/firstdigital.png',
  USDP:     'https://assets.coingecko.com/coins/images/6013/small/Pax_Dollar.png',
  LUSD:     'https://assets.coingecko.com/coins/images/14666/small/Group_3.png',
  CRVUSD:   'https://assets.coingecko.com/coins/images/30118/small/crvusd.png',
  GHO:      'https://assets.coingecko.com/coins/images/30663/small/gho-token-logo.png',
  USDS:     'https://assets.coingecko.com/coins/images/33706/small/usds.png',
  USD0:     'https://assets.coingecko.com/coins/images/36706/small/usd0.png',
  USDe:     'https://assets.coingecko.com/coins/images/33613/small/usde.png',
  BOLD:     'https://assets.coingecko.com/coins/images/37053/small/bold.png',
  EURC:     'https://assets.coingecko.com/coins/images/26045/small/euro-coin.png',
  EURS:     'https://assets.coingecko.com/coins/images/5164/small/EURS_300x300.png',

  // ── Wrapped assets ────────────────────────────────────────────────────────
  WETH:     'https://assets.coingecko.com/coins/images/2518/small/weth.png',
  WBTC:     'https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png',
  WBNB:     'https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png',
  WAVAX:    'https://assets.coingecko.com/coins/images/12559/small/Avalanche_Circle_RedWhite_Trans.png',
  WSOL:     'https://assets.coingecko.com/coins/images/4128/small/solana.png',
  CBBTC:    'https://assets.coingecko.com/coins/images/40132/small/cbbtc.png',
  LBTC:     'https://assets.coingecko.com/coins/images/37800/small/lbtc.png',
  FBTC:     'https://assets.coingecko.com/coins/images/36627/small/fbtc.png',
  STETH:    'https://assets.coingecko.com/coins/images/13442/small/steth_logo.png',
  WSTETH:   'https://assets.coingecko.com/coins/images/18834/small/wstETH.png',
  RETH:     'https://assets.coingecko.com/coins/images/20764/small/reth.png',
  CBETH:    'https://assets.coingecko.com/coins/images/27008/small/cbeth.png',
  ETHX:     'https://assets.coingecko.com/coins/images/30870/small/ethx.png',

  // ── DeFi blue chips ───────────────────────────────────────────────────────
  LINK:     'https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png',
  UNI:      'https://assets.coingecko.com/coins/images/12504/small/uniswap-uni.png',
  AAVE:     'https://assets.coingecko.com/coins/images/12645/small/AAVE.png',
  MKR:      'https://assets.coingecko.com/coins/images/1364/small/Mark_Maker.png',
  CRV:      'https://assets.coingecko.com/coins/images/12124/small/Curve.png',
  CVX:      'https://assets.coingecko.com/coins/images/15585/small/convex.png',
  LDO:      'https://assets.coingecko.com/coins/images/13573/small/Lido_DAO.png',
  RPL:      'https://assets.coingecko.com/coins/images/2090/small/rocket_pool_%28RPL%29.png',
  COMP:     'https://assets.coingecko.com/coins/images/10775/small/COMP.png',
  SNX:      'https://assets.coingecko.com/coins/images/3406/small/SNX.png',
  BAL:      'https://assets.coingecko.com/coins/images/11683/small/Balancer.png',
  SUSHI:    'https://assets.coingecko.com/coins/images/12271/small/sushi.png',
  '1INCH':  'https://assets.coingecko.com/coins/images/13469/small/1inch-token.png',
  GMX:      'https://assets.coingecko.com/coins/images/18323/small/gmx.png',
  GNO:      'https://assets.coingecko.com/coins/images/662/small/logo_square_simple_300px.png',
  LQTY:     'https://assets.coingecko.com/coins/images/14665/small/200-lqty-icon.png',
  FXS:      'https://assets.coingecko.com/coins/images/13423/small/frax_share.png',
  MORPHO:   'https://assets.coingecko.com/coins/images/29837/small/morpho.png',
  ENA:      'https://assets.coingecko.com/coins/images/36530/small/ethena.png',
  PENDLE:   'https://assets.coingecko.com/coins/images/15069/small/Pendle_Logo_Normal-03.png',
  SKY:      'https://assets.coingecko.com/coins/images/35033/small/sky.png',
  SAFE:     'https://assets.coingecko.com/coins/images/27032/small/SafeLogo.png',
  COW:      'https://assets.coingecko.com/coins/images/24384/small/CoW.png',
  GRT:      'https://assets.coingecko.com/coins/images/13311/small/the_graph.png',
  FET:      'https://assets.coingecko.com/coins/images/5681/small/Fetch.jpg',
  ONDO:     'https://assets.coingecko.com/coins/images/26580/small/ONDO.png',
  W:        'https://assets.coingecko.com/coins/images/35787/small/wormhole.png',
  EIGEN:    'https://assets.coingecko.com/coins/images/33063/small/eigen.png',
  ETHFI:    'https://assets.coingecko.com/coins/images/35958/small/ethfi.png',
  FLUID:    'https://assets.coingecko.com/coins/images/37084/small/fluid.png',
  SD:       'https://assets.coingecko.com/coins/images/20658/small/sd.png',
  VIRTUAL:  'https://assets.coingecko.com/coins/images/34613/small/virtual.png',

  // ── Layer 2 / rollup tokens ───────────────────────────────────────────────
  ARB:      'https://assets.coingecko.com/coins/images/16547/small/arb.jpg',
  OP:       'https://assets.coingecko.com/coins/images/25244/small/Optimism.png',
  MNT:      'https://assets.coingecko.com/coins/images/30980/small/mantle.png',
  ZK:       'https://assets.coingecko.com/coins/images/24091/small/zksync.png',
  STRK:     'https://assets.coingecko.com/coins/images/26433/small/starknet.png',
  IMX:      'https://assets.coingecko.com/coins/images/17233/small/immutableX-symbol-BLK-RGB.png',
  METIS:    'https://assets.coingecko.com/coins/images/15595/small/metis.png',
  ZRO:      'https://assets.coingecko.com/coins/images/28206/small/linea.png',
  SEI:      'https://assets.coingecko.com/coins/images/28205/small/Sei_Logo_-_Transparent.png',
  TIA:      'https://assets.coingecko.com/coins/images/31967/small/tia.jpg',
  MANTA:    'https://assets.coingecko.com/coins/images/31463/small/manta.png',

  // ── Meme coins ────────────────────────────────────────────────────────────
  SHIB:     'https://assets.coingecko.com/coins/images/11939/small/shiba.png',
  PEPE:     'https://assets.coingecko.com/coins/images/29850/small/pepe-token.jpeg',
  FLOKI:    'https://assets.coingecko.com/coins/images/16746/small/PNG_image.png',
  BONK:     'https://assets.coingecko.com/coins/images/28600/small/bonk.jpg',
  WIF:      'https://assets.coingecko.com/coins/images/33566/small/dogwifhat.jpg',
  BOME:     'https://assets.coingecko.com/coins/images/36000/small/bome.png',
  POPCAT:   'https://assets.coingecko.com/coins/images/33383/small/popcat.png',
  TRUMP:    'https://assets.coingecko.com/coins/images/35836/small/1000048858.jpg',
  MELANIA:  'https://assets.coingecko.com/coins/images/35837/small/melania.png',
  PENGU:    'https://assets.coingecko.com/coins/images/34658/small/pengu.png',
  MOG:      'https://assets.coingecko.com/coins/images/30986/small/mog.jpg',
  SPX:      'https://assets.coingecko.com/coins/images/31401/small/spx6900.jpg',
  TURBO:    'https://assets.coingecko.com/coins/images/29117/small/turbo.png',
  GROK:     'https://assets.coingecko.com/coins/images/32933/small/grok.png',
  MOODENG:  'https://assets.coingecko.com/coins/images/36998/small/moodeng.png',
  NEIRO:    'https://assets.coingecko.com/coins/images/36645/small/neiro.jpg',
  BOBO:     'https://assets.coingecko.com/coins/images/30291/small/bobo.jpeg',
  MEME:     'https://assets.coingecko.com/coins/images/29026/small/meme.jpg',
  BABYDOGE: 'https://assets.coingecko.com/coins/images/16035/small/babydoge.jpg',
  DINU:     'https://assets.coingecko.com/coins/images/23566/small/dinu.png',
  AKITA:    'https://assets.coingecko.com/coins/images/14364/small/akita.png',
  KISHU:    'https://assets.coingecko.com/coins/images/14637/small/kishu.png',
  ELON:     'https://assets.coingecko.com/coins/images/14681/small/elon.png',
  APU:      'https://assets.coingecko.com/coins/images/35836/small/1000048858.jpg',

  // ── Solana DeFi & ecosystem ───────────────────────────────────────────────
  JUP:      'https://assets.coingecko.com/coins/images/34182/small/jup.png',
  RAY:      'https://assets.coingecko.com/coins/images/13928/small/ray.png',
  ORCA:     'https://assets.coingecko.com/coins/images/17547/small/orca.png',
  JTO:      'https://assets.coingecko.com/coins/images/34183/small/jto.png',
  PYTH:     'https://assets.coingecko.com/coins/images/31924/small/pyth.png',
  RENDER:   'https://assets.coingecko.com/coins/images/11636/small/rndr.png',
  HNT:      'https://assets.coingecko.com/coins/images/4284/small/Helium_HNT.jpg',
  MOBILE:   'https://assets.coingecko.com/coins/images/28415/small/mobile-token.jpg',
  IOT:      'https://assets.coingecko.com/coins/images/28413/small/iot-token.jpg',
  MNDE:     'https://assets.coingecko.com/coins/images/18867/small/MNDE.png',
  MSOL:     'https://assets.coingecko.com/coins/images/18863/small/mSOL.png',
  STSOL:    'https://assets.coingecko.com/coins/images/18364/small/stSol.png',

  // ── Base ecosystem ────────────────────────────────────────────────────────
  BRETT:    'https://assets.coingecko.com/coins/images/35585/small/brett.png',
  VVV:      'https://assets.coingecko.com/coins/images/36918/small/venice-token.png',
  KAITO:    'https://assets.coingecko.com/coins/images/36919/small/kaito.png',
  AERO:     'https://assets.coingecko.com/coins/images/31745/small/token.png',

  // ── THORChain ecosystem ───────────────────────────────────────────────────
  THOR:     'https://assets.coingecko.com/coins/images/13677/small/RUNE_ICON.png',
  VTHOR:    'https://assets.coingecko.com/coins/images/30573/small/vthor.png',

  // ── Real World Assets (RWA) ───────────────────────────────────────────────
  PAXG:     'https://assets.coingecko.com/coins/images/9519/small/paxg.PNG',
  XAUT:     'https://assets.coingecko.com/coins/images/10415/small/Tether_Gold.png',
  XAUt:     'https://assets.coingecko.com/coins/images/10415/small/Tether_Gold.png',

  // ── AI / Data tokens ─────────────────────────────────────────────────────
  RNDR:     'https://assets.coingecko.com/coins/images/11636/small/rndr.png',
  AGIX:     'https://assets.coingecko.com/coins/images/2798/small/SingularityNET.png',
  OCEAN:    'https://assets.coingecko.com/coins/images/3687/small/ocean-protocol-logo.jpg',
  NMR:      'https://assets.coingecko.com/coins/images/752/small/numeraire.png',
  TAO:      'https://assets.coingecko.com/coins/images/28452/small/ARUsPeNQ_400x400.jpeg',

  // ── GameFi / Metaverse ────────────────────────────────────────────────────
  AXS:      'https://assets.coingecko.com/coins/images/13029/small/axie_infinity_logo.png',
  SLP:      'https://assets.coingecko.com/coins/images/10366/small/SLP.png',
  SAND:     'https://assets.coingecko.com/coins/images/12129/small/sandbox_logo.jpg',
  MANA:     'https://assets.coingecko.com/coins/images/878/small/decentraland-mana.png',
  ENJ:      'https://assets.coingecko.com/coins/images/1102/small/enjin-coin-logo.png',
  GALA:     'https://assets.coingecko.com/coins/images/12493/small/GALA-COINGECKO.png',
  ILV:      'https://assets.coingecko.com/coins/images/14468/small/ILV.JPG',
  YGG:      'https://assets.coingecko.com/coins/images/17631/small/ygg_logo.png',
  GUILD:    'https://assets.coingecko.com/coins/images/21271/small/BGS_logo.jpg',
  APE:      'https://assets.coingecko.com/coins/images/24383/small/apecoin.jpg',

  // ── Exchange tokens ───────────────────────────────────────────────────────
  CRO:      'https://assets.coingecko.com/coins/images/7310/small/cro_token_logo.png',
  OKB:      'https://assets.coingecko.com/coins/images/4463/small/WeChat_Image_20220118095654.png',
  HT:       'https://assets.coingecko.com/coins/images/2822/small/huobi-token-logo.png',
  KCS:      'https://assets.coingecko.com/coins/images/1047/small/sa9z79.png',
  WOO:      'https://assets.coingecko.com/coins/images/12921/small/w2UiEmF1_400x400.jpg',

  // ── Additional DeFi / misc ────────────────────────────────────────────────
  BAND:     'https://assets.coingecko.com/coins/images/9545/small/Band_token_blue_violet_token.png',
  KNC:      'https://assets.coingecko.com/coins/images/947/small/kyber-network.png',
  API3:     'https://assets.coingecko.com/coins/images/13256/small/api3.jpg',
  BADGER:   'https://assets.coingecko.com/coins/images/13287/small/badger_dao_logo.jpg',
  AMP:      'https://assets.coingecko.com/coins/images/12409/small/amp-200x200.png',
  AUDIO:    'https://assets.coingecko.com/coins/images/14913/small/2021-03-28.png',
  DODO:     'https://assets.coingecko.com/coins/images/12651/small/dodo_logo.png',
  ALPHA:    'https://assets.coingecko.com/coins/images/1374/small/alpha-finance.jpg',
  PERP:     'https://assets.coingecko.com/coins/images/12381/small/60d18e06844a844ad75901a9_mark_only_03.png',
  DYDX:     'https://assets.coingecko.com/coins/images/17500/small/hjnIm9bV.jpg',
  INJ:      'https://assets.coingecko.com/coins/images/12882/small/Secondary_Symbol.png',
  REQ:      'https://assets.coingecko.com/coins/images/1031/small/Request_icon_green.png',
  RLC:      'https://assets.coingecko.com/coins/images/646/small/pL1VuXm.png',
  STORJ:    'https://assets.coingecko.com/coins/images/949/small/storj.png',
  JASMY:    'https://assets.coingecko.com/coins/images/13876/small/JASMY200x200.jpg',
  GLM:      'https://assets.coingecko.com/coins/images/542/small/Golem_Submark_Positive_RGB.png',
  NKN:      'https://assets.coingecko.com/coins/images/3375/small/nkn.png',
  MASK:     'https://assets.coingecko.com/coins/images/14051/small/Mask_Network.jpg',
  POWR:     'https://assets.coingecko.com/coins/images/1104/small/power-ledger.png',
  ANKR:     'https://assets.coingecko.com/coins/images/8912/small/ankr.png',
  BLZ:      'https://assets.coingecko.com/coins/images/2848/small/ColorIcon_3x.png',
  DENT:     'https://assets.coingecko.com/coins/images/1168/small/dent.png',
  HOT:      'https://assets.coingecko.com/coins/images/3348/small/Holo_ICON_Black_Circle.png',
  IOTX:     'https://assets.coingecko.com/coins/images/3334/small/iotex-logo.png',
  MTL:      'https://assets.coingecko.com/coins/images/763/small/Metal.png',
  REEF:     'https://assets.coingecko.com/coins/images/13504/small/Group_10572.jpg',
  SXP:      'https://assets.coingecko.com/coins/images/9368/small/swipe.png',
  TRB:      'https://assets.coingecko.com/coins/images/9644/small/Tellor_logo.jpg',
  WLD:      'https://assets.coingecko.com/coins/images/31069/small/worldcoin.jpeg',
  XVS:      'https://assets.coingecko.com/coins/images/12677/small/download.jpg',
  IDEX:     'https://assets.coingecko.com/coins/images/2565/small/logomark-purple-286x286.png',
  LPT:      'https://assets.coingecko.com/coins/images/7137/small/logo-circle-green.png',
  ORN:      'https://assets.coingecko.com/coins/images/11841/small/orion_protocol.png',
  UFT:      'https://assets.coingecko.com/coins/images/12819/small/UniLend_Finance_logo_PNG.png',
  XRT:      'https://assets.coingecko.com/coins/images/3154/small/robonomics-network-xrt-logo.png',
  CELR:     'https://assets.coingecko.com/coins/images/4379/small/Celer.png',
  DATA:     'https://assets.coingecko.com/coins/images/17869/small/DATA_new_symbol.png',
  KEEP:     'https://assets.coingecko.com/coins/images/11835/small/chainlink.png',
  LINA:     'https://assets.coingecko.com/coins/images/12509/small/linear-icon.png',
  NU:       'https://assets.coingecko.com/coins/images/3318/small/photo1198982838879365035.jpg',
  RAMP:     'https://assets.coingecko.com/coins/images/12837/small/RAMP-Logo-v2-1000pxsq.png',
  TROY:     'https://assets.coingecko.com/coins/images/10811/small/TROY_logo_264.png',
  SPARTA:   'https://assets.coingecko.com/coins/images/12638/small/SPARTA-token.png',
  HARD:     'https://assets.coingecko.com/coins/images/13204/small/HARD.png',
  CAKE:     'https://assets.coingecko.com/coins/images/12428/small/cake.png',
  XDAI:     'https://assets.coingecko.com/coins/images/1104/small/xdai.png',
  GNS:      'https://assets.coingecko.com/coins/images/19737/small/logo_colorful_300px.png',
  STPT:     'https://assets.coingecko.com/coins/images/8713/small/STP.png',
  AUCTION:  'https://assets.coingecko.com/coins/images/13860/small/1_KtgpRIJzuwfHe0Rl0avP_g.jpeg',

  // ── Stacks / Bitcoin DeFi ─────────────────────────────────────────────────
  STX:      'https://assets.coingecko.com/coins/images/2069/small/Stacks_logo_full.png',

  // ── Tokenized stocks (Robinhood / HOOD chain) ─────────────────────────────
  // These appear on the HOOD chain via SwapKit
  AAPL:     'https://assets.coingecko.com/coins/images/1/small/bitcoin.png',
  TSLA:     'https://assets.coingecko.com/coins/images/1/small/bitcoin.png',
  NVDA:     'https://assets.coingecko.com/coins/images/1/small/bitcoin.png',
  MSFT:     'https://assets.coingecko.com/coins/images/1/small/bitcoin.png',
  GOOGL:    'https://assets.coingecko.com/coins/images/1/small/bitcoin.png',
  AMZN:     'https://assets.coingecko.com/coins/images/1/small/bitcoin.png',
  META:     'https://assets.coingecko.com/coins/images/1/small/bitcoin.png',
  GME:      'https://assets.coingecko.com/coins/images/1/small/bitcoin.png',
  // ^^ HOOD chain tokenized stocks don't have CoinGecko icons; using BTC as
  //    placeholder. TokenImage will fall back to generating a letter avatar.
};

// ─── CHAIN COLORS ─────────────────────────────────────────────────────────────
// Used for chain badges, borders, and accent colours in the UI.

export const CHAIN_COLORS = {
  Bitcoin:          '#f7931a',
  Ethereum:         '#627eea',
  Solana:           '#9945ff',
  Monero:           '#ff6600',
  Base:             '#0052ff',
  Arbitrum:         '#28a0f0',
  'BNB Chain':      '#f3ba2f',
  Polygon:          '#8247e5',
  Avalanche:        '#e84142',
  Optimism:         '#ff0420',
  Gnosis:           '#133629',
  Stellar:          '#14b6e6',
  Cardano:          '#0033ad',
  Litecoin:         '#345d9d',
  Dogecoin:         '#c2a633',
  XRP:              '#23292f',
  Tron:             '#ff060a',
  TON:              '#0088cc',
  Sui:              '#4da2a9',
  Aptos:            '#111111',
  Near:             '#00c08b',
  Aleo:             '#2d2d2d',
  Movement:         '#000000',
  Starknet:         '#29236a',
  Scroll:           '#cba68b',
  Berachain:        '#814625',
  Monad:            '#836ef9',
  HyperEVM:         '#00d4aa',
  'X Layer':        '#1c1c1c',
  Plasma:           '#6366f1',
  Hypercore:        '#00d4aa',
  Abstract:         '#222222',
  Fantom:           '#1969ff',
  Linea:            '#61dfff',
  zkSync:           '#8c8dfc',
  Mantle:           '#1ed38e',
  Manta:            '#00a0ff',
  Blast:            '#fcfc03',
  Mode:             '#dffe00',
  Robinhood:        '#00c805',
  Kujira:           '#f04c0f',
  THORChain:        '#33ff99',
  'Maya Protocol':  '#0077ff',
  Polkadot:         '#e6007a',
  Cosmos:           '#2e3148',
  Zcash:            '#f4b728',
  'Bitcoin Cash':   '#0ac18e',
  Dash:             '#008de4',
  Stacks:           '#5546ff',
  Radix:            '#052cc0',
};

// ─── CEX / EXCHANGE ICONS ─────────────────────────────────────────────────────
export const CEX_ICONS = {
  binance: 'https://assets.coingecko.com/markets/images/52/small/binance.jpg',
  kucoin: 'https://assets.coingecko.com/markets/images/61/small/kucoin.png',
  bybit: 'https://assets.coingecko.com/markets/images/698/standard/bybit_spot.png?',
  mexc: 'https://assets.coingecko.com/markets/images/409/standard/164286be-32a5-4b58-978c-d072eea00eb9.jpeg',
  gate: 'https://assets.coingecko.com/markets/images/60/standard/Frame_1.png',
  bitfinex: 'https://assets.coingecko.com/markets/images/4/small/bitfinex.png',
  htx: 'https://assets.coingecko.com/markets/images/25/standard/htx.png',
  huobi: 'https://assets.coingecko.com/markets/images/25/small/huobi.png',
  whitebit: 'https://assets.coingecko.com/markets/images/418/standard/800_800.jpg',
  kraken: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/24.png',
  hitbtc: 'https://s2.coinmarketcap.com/static/img/exchanges/64x64/42.png',

  btse: 'https://assets.coingecko.com/markets/images/108/standard/btse.png',
  bingx: 'https://assets.coingecko.com/markets/images/812/standard/bingx.png',
  bitget: 'https://assets.coingecko.com/markets/images/540/standard/Bitget_logo.png',
  bitstamp: 'https://assets.coingecko.com/markets/images/9/standard/bitstamp.jpg',
  bitvavo: 'https://assets.coingecko.com/markets/images/318/standard/bitvavo.jpg',
  coinbase: 'https://assets.coingecko.com/markets/images/23/standard/Coinbase_Coin_Primary.png',
  coinw: 'https://assets.coingecko.com/markets/images/193/standard/coinw.png',
  cryptocom: 'https://assets.coingecko.com/markets/images/589/standard/Crypto.com.png',
  lbank: 'https://assets.coingecko.com/markets/images/118/standard/lbank.png',
  okx: 'https://assets.coingecko.com/markets/images/96/standard/okx.png',
  phemex: 'https://assets.coingecko.com/markets/images/564/standard/phemex.png',
  pionex: 'https://assets.coingecko.com/markets/images/948/standard/pionex.png',
  poloniex: 'https://assets.coingecko.com/markets/images/37/standard/poloniex.png',
  toobit: 'https://assets.coingecko.com/markets/images/1186/standard/toobit.png',
  weex: 'https://assets.coingecko.com/markets/images/1165/standard/weex.png',
  xt: 'https://assets.coingecko.com/markets/images/404/standard/xt.png',
  bitunix: 'https://assets.coingecko.com/markets/images/1176/standard/bitunix.png',
  bitmart: 'https://assets.coingecko.com/markets/images/239/standard/bitmart.png',
  coinex: 'https://assets.coingecko.com/markets/images/135/standard/coinex.png',
  bitrue: 'https://assets.coingecko.com/markets/images/277/standard/bitrue.png',
  deepcoin: 'https://assets.coingecko.com/markets/images/1062/standard/deepcoin.png'
};